/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['կգ․', 'կօ․', 'առվ', 'ցրկ', 'երկ', 'գշր'],
    [
      'կեսգիշեր', 'կեսօր', 'առավոտյան', 'ցերեկը', 'երեկոյան',
      'գիշերը'
    ],
    [
      'կեսգիշերին', 'կեսօրին', 'առավոտյան', 'ցերեկը',
      'երեկոյան', 'գիշերը'
    ]
  ],
  [
    ['կեսգիշեր', 'կեսօր', 'առավոտ', 'ցերեկ', 'երեկո', 'գիշեր'],
    ,
  ],
  [
    '00:00', '12:00', ['06:00', '12:00'], ['12:00', '18:00'], ['18:00', '24:00'],
    ['00:00', '06:00']
  ]
];
